/* eslint-disable max-len */
/* eslint-disable max-len */
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import InsightsIcon from '@mui/icons-material/Insights'; // Import the new icon
import TableChartIcon from '@mui/icons-material/TableChart';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import getLatestIndexJobDetails from '../../api/oc_product/Dashboard/gets/getIndexLatestJobDetails';
import getAllDeploymentDetails from '../../api/private/deployment/getAllDeploymentDetails';
import { getLocalStorage } from '../../helper/LocalStorage';
import ReleaseNotes from './components/ReleaseNotes';
import WarningMessage from './components/WarningMessage';

function Dashboard() {
  const matches = useMediaQuery('(min-width:600px)');
  const user = useSelector((state) => state.user.userProfile);
  const selectedSite = useSelector((state) => state.user.loginResponse.selectedSite);

  const hideReleaseNotesKey = 'hide-release-notes-20251128';
  const hideReleaseNotes = getLocalStorage(hideReleaseNotesKey);
  const noLongerShowReleaseNotes = Date.now() > new Date('2025-11-28T00:00:00');

  const [hideReleaseNotification, setHideReleaseNotification] = React.useState(false);
  React.useEffect(() => {
    setHideReleaseNotification(!hideReleaseNotes && !noLongerShowReleaseNotes);
  }, [hideReleaseNotes, noLongerShowReleaseNotes]);

  const isUserAdminOrAppManager = user?.user_permission === 'Admin'
    || user?.user_permission === 'GroupAdmin'
    || user?.user_permission === 'User'
    || user?.user_permission === 'Viewer';

  const [warningMsgEndDate, setWarningMsgEndDate] = React.useState('');
  const [maintenanceDate, setMaintenanceDate] = React.useState();
  // const warningMsg = 'Prism will be down during the scheduled time';
  const [warningMsg, setWarningMsgState] = React.useState('');
  const [durationofIndexJob, setDurationofIndexJob] = React.useState(0);
  const [durationofDeleteJob, setDurationofDeleteJob] = React.useState(0);
  const [totalDeleteProducts, setTotalDeleteProducts] = React.useState(0);

  const [deploymentStartTime, setDeploymentStartTime] = React.useState(0);
  const [deploymentEndTime, setDeploymentEndTime] = React.useState(0);

  const reasonMsg = 'Stability update';
  const [nextReleaseDate, setNextReleaseDate] = React.useState('No Schedule');

  const [latestIndexJobDetails, setLatestIndexJobDetails] = React.useState(null);
  const [latestDeleteIndexJobDetails, setLatestDeleteIndexJobDetails] = React.useState(null);

const getNextReleaseText = (items) => {
    const today = new Date().toISOString();
    if (items.DeploymentMode === 'Yes' && items.releaseNote !== '') {
      const scheduled = new Date(items.StartTime);
      const currentTime = new Date(today);
      if (scheduled >= currentTime) {
        return items.StartTime;
      }
    }
    return 'No Schedule';
  };
const fetchLogs = async () => {
    try {
      await getAllDeploymentDetails(1, 15)
        .then((response) => {
          const result = getNextReleaseText(response.data.Data[0]);
          if (response.data.Data[0].DeploymentMode === 'Yes') {
             setWarningMsgEndDate(response.data.Data[0].EndTime);
            console.log('enddate:', response.data.Data[0].EndTime);
            setNextReleaseDate(result);
            setMaintenanceDate(result);
           const startHours = new Date(response.data.Data[0].StartTime).getHours();
           const startMinutes = new Date(response.data.Data[0].StartTime).getMinutes().toString().padStart(2, '0');
            const endHours = new Date(response.data.Data[0].EndTime).getHours();
           const endMinutes = new Date(response.data.Data[0].EndTime).getMinutes().toString().padStart(2, '0');
        setDeploymentStartTime(`${startHours}:${startMinutes}`);
        setDeploymentEndTime(`${endHours}:${endMinutes}`);
          } else {
            setNextReleaseDate('No Schedule');
          }
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error('Error fetching user activity logs:', error);
    }
  };
   React.useEffect(() => {
    if (nextReleaseDate !== 'No Schedule') {
    fetchLogs();

  const release = new Date(nextReleaseDate).getTime();
  const end = new Date(warningMsgEndDate).getTime();
  const now = Date.now();
const diffInms = release - now;
const diffinDays = (diffInms / (1000 * 60 * 60 * 24));
  if (diffinDays <= 7 && now < release) {
      setWarningMsgState('Prism will be undergoing scheduled maintenance');
    } else if (now >= release && now <= end) {
      setWarningMsgState('Prism is currently undergoing scheduled maintenance');
    } else {
 setWarningMsgState('');
}
}
  }, []);
  React.useEffect(() => {
    getLatestIndexJobDetails().then((response) => {
      if (response.data[0].JobName === 'PeriodicIndexingJob') {
        setLatestIndexJobDetails(response.data[0]);
        setDurationofIndexJob((new Date(response.data[0].End) - new Date(response.data[0].StartTrigger)) / 1000);
      }
      if (response.data[1].JobName === 'DeleteMissingProductFromElasticJob') {
        setLatestDeleteIndexJobDetails(response.data[1]);
        const deleteCount = response.data[1].Message.match(/^\d+/gm)?.map(Number) || 0;
        const total = deleteCount.reduce((acc, val) => acc + val, 0);
        setTotalDeleteProducts(total);
        setDurationofDeleteJob((new Date(response.data[1].End) - new Date(response.data[1].StartTrigger)) / 1000);
      }
    })
      .catch((error) => {
        console.error('Error fetching latest index job details:', error);
      });
  }, []);
  return (
    <Container maxWidth="xl" className="relative h-full pt-6">
      <Typography variant={matches ? 'h4' : 'h5'} className="pb-8 font-gothamlight" textTransform="capitalize">
        Welcome
        {' '}
        {user.sub}
      </Typography>
      {(hideReleaseNotification && isUserAdminOrAppManager && new Date() > new Date(warningMsgEndDate))
        && <ReleaseNotes hideKey={hideReleaseNotesKey} onHide={() => setHideReleaseNotification(false)} />}
      {(new Date() < new Date(warningMsgEndDate)) && <WarningMessage date={nextReleaseDate} start={deploymentStartTime} end={deploymentEndTime} reason={reasonMsg} />}
      <div className="relative mt-8 pb-16">
        <section className="relative mt-8 pb-16">
      {(new Date() < new Date(warningMsgEndDate)) && <WarningMessage date={nextReleaseDate} start={deploymentStartTime} end={deploymentEndTime} reason={reasonMsg} />}
          <div className="w-full mb-8 border-b border-neutral-600">
            <Typography variant="h6" className="tracking-widest font-gothambold">
              QUICK LINKS
            </Typography>
          </div>
          <Stack
            direction="row"
            spacing={matches ? 8 : 2}
            justifyContent={matches ? 'flex-start' : 'space-evenly'}
          >
            {user?.user_groupName !== 'ImageChecker' && selectedSite?.SiteCode !== 'OC' && selectedSite?.SiteCode !== 'JQ' && (
            <a
              href="/dropship/wizards/product"
              className={`
              bg-white
              shadow
              w-[150px] h-[150px] md:w-64 md:h-64
              active:scale-95 transition-transform
              hover:border-neutral-200 border border-transparent
            `}
            >
              <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-8">
                <AutoFixHighIcon className="text-[4rem] md:text-[6rem]" />
                <Typography
                  variant={matches ? 'h5' : 'h6'}
                  textAlign="center"
                  letterSpacing="1px"
                  fontFamily="gothambold"
                >
                  DROPSHIP
                  <br />
                  WIZARD
                </Typography>
              </div>
            </a>
            )}
            {user?.user_groupName !== 'ImageChecker' && selectedSite?.SiteCode !== 'OC' && selectedSite?.SiteCode !== 'JQ' && isUserAdminOrAppManager && (
            <Link
              to="/product-info/products"
              className={`
                bg-white
                shadow
                w-[150px] h-[150px] md:w-64 md:h-64
                active:scale-95 transition-transform
                hover:border-neutral-200 border border-transparent
              `}
            >
              <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-8">
                <TableChartIcon className="text-[4rem] md:text-[6rem]" />
                <Typography
                  variant={matches ? 'h5' : 'h6'}
                  textAlign="center"
                  letterSpacing="2px"
                  fontFamily="gothambold"
                >
                  PRODUCTS
                  <br />
                  TABLE
                </Typography>
              </div>
            </Link>
            )}
            {user?.user_groupName !== 'ImageChecker' && selectedSite?.SiteCode !== 'JQ' && (
            <a
              href="/bulk-operations"
              className={`
              bg-white
              shadow
              w-[150px] h-[150px] md:w-64 md:h-64
              active:scale-95 transition-transform
              hover:border-neutral-200 border border-transparent
            `}
            >
              <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-8">
                <DynamicFeedIcon className="text-[4rem] md:text-[6rem]" />
                <Typography
                  variant={matches ? 'h5' : 'h6'}
                  textAlign="center"
                  letterSpacing="1px"
                  fontFamily="gothambold"
                >
                  BULK
                  <br />
                  UPLOADS
                </Typography>
              </div>
            </a>
            )}

            {user?.user_groupName !== 'ImageChecker' && selectedSite?.SiteCode !== 'OC' && selectedSite?.SiteCode !== 'JQ' && (
            <a
              href="/data-management/brand-grouping"
              className={`
              bg-white
              shadow
              w-[150px] h-[150px] md:w-64 md:h-64
              active:scale-95 transition-transform
              hover:border-neutral-200 border border-transparent
            `}
            >
              <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-8">
                <GroupAddIcon className="text-[4rem] md:text-[6rem]" />
                <Typography
                  variant={matches ? 'h5' : 'h6'}
                  textAlign="center"
                  letterSpacing="1px"
                  fontFamily="gothambold"
                >
                  BRAND
                  <br />
                  GROUPING
                </Typography>
              </div>
            </a>
            )}
            {user?.user_groupName !== 'ImageChecker' && selectedSite?.SiteCode === 'JQ' && (
            <a
              href="/margin-threshold"
              className={`
              bg-white
              shadow
              w-[150px] h-[150px] md:w-64 md:h-64
              active:scale-95 transition-transform
              hover:border-neutral-200 border border-transparent
            `}
            >
              <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-8">
                <InsightsIcon className="text-[4rem] md:text-[6rem]" />
                <Typography
                  variant={matches ? 'h5' : 'h6'}
                  textAlign="center"
                  letterSpacing="1px"
                  fontFamily="gothambold"
                >
                  MARGIN
                  <br />
                  THRESHOLD
                </Typography>
              </div>
            </a>
            )}
            {(user?.user_groupName === 'ImageChecker' || (isUserAdminOrAppManager && selectedSite?.SiteCode !== 'OC' && selectedSite?.SiteCode !== 'JQ')) && (
            <a
              href="/image-checker"
              className={`
              bg-white
              shadow
              w-[150px] h-[150px] md:w-64 md:h-64
              active:scale-95 transition-transform
              hover:border-neutral-200 border border-transparent
            `}
            >
              <div className="flex flex-col items-center justify-center h-full gap-2 md:gap-8">
                <ImageSearchIcon className="text-[4rem] md:text-[6rem]" />
                <Typography
                  variant={matches ? 'h5' : 'h6'}
                  textAlign="center"
                  letterSpacing="1px"
                  fontFamily="gothambold"
                >
                  Image
                  <br />
                  Checker
                </Typography>
              </div>
            </a>
            )}
          </Stack>
        </section>
        <section className="relative mt-2 pb-16">
          <div className="w-full mt-[50px] mb-2 border-b border-neutral-600">
            <Typography variant="h6" className="tracking-widest font-gothambold">
              MONITORING
            </Typography>
          </div>
          <Stack
            direction="row"
            spacing={matches ? 8 : 2}
            justifyContent={matches ? 'flex-start' : 'space-evenly'}
          >
            {user?.user_groupName !== 'ImageChecker' && selectedSite?.SiteCode !== 'OC' && selectedSite?.SiteCode !== 'JQ' && (
              <>
                <div className={`
                bg-white
                shadow
                w-full max-w-[600px] mx-auto min-h-[250px]
                hover:border-neutral-200 border border-transparent
              `}
                >
                  <Typography
                    variant={matches ? 'h5' : 'h6'}
                    textAlign="center"
                    letterSpacing="1px"
                    fontFamily="gothambold"
                  >
                    Bulk Uploads
                  </Typography>
                  <div className="grid grid-cols-1 md:grid-cols-1 items-strech justify-items-center w-full mt-12 gap-2 px-18">
                    <div className="bg-white rounded-2xl shadow p-5 h-full border max-w-[400px] border-neutral-100 space-y-2">
                      <Typography
                        textAlign="center"
                        fontFamily="gothambold"
                      >
                        Coming Soon
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className={`
                bg-white
                shadow
                w-full max-w-[600px] mx-auto min-h-[200px]
                hover:border-neutral-200 border border-transparent
              `}
                >
                  <Typography
                    variant={matches ? 'h5' : 'h6'}
                    textAlign="center"
                    letterSpacing="1px"
                    fontFamily="gothambold"
                  >
                    Indexing
                  </Typography>
                  {latestIndexJobDetails && latestDeleteIndexJobDetails && (

                    <div className="grid grid-cols-1 md:grid-cols-2 items-strech justify-items-center w-full mt-1 gap-1 px-16">
                      <div className="bg-white rounded-2xl shadow p-5 h-full border max-w-[400px] border-neutral-100 space-y-2">
                        <Typography
                          textAlign="left"
                          fontFamily="gothambold"
                        >
                          Full index job
                        </Typography>
                        <p>
                          Start Date :
                          {' '}
                          {latestIndexJobDetails.StartTrigger.split('T')[0]}
                        </p>
                        <p>
                          Start Time :
                          {' '}
                          {latestIndexJobDetails.StartTrigger.split('T')[1].split('.')[0]}
                        </p>
                        <p>
                          Duration :
                          {' '}
                          {durationofIndexJob}
                          {' '}
                          {' '}
                          sec
                        </p>
                        <p>
                          Status :
                          {' '}
                          {latestIndexJobDetails.FailedTrigger ? (
                            <span style={{ color: 'red' }}>
                              Failed
                            </span>
                          ) : <span style={{ color: 'green' }}>Passed</span>}
                        </p>
                        {latestIndexJobDetails.FailedTrigger ? (
                          <>
                            <p>
                              Message :
                              {' '}
                            </p>
                            <span>
                              {latestIndexJobDetails.Message}

                            </span>
                          </>
                        ) : (
                          <p>
                            Count :
                            {' '}
                            {latestIndexJobDetails.Message.split(' ')[4]}

                          </p>
                        )}

                      </div>
                      <div className="bg-white rounded-2xl shadow p-5 h-full max-w-[400px] border border-neutral-100 space-y-2">
                        {' '}
                        <Typography
                          textAlign="left"
                          fontFamily="gothambold"
                        >
                          Delete index job
                        </Typography>
                        <p>
                          Start Date :
                          {' '}
                          {latestDeleteIndexJobDetails.StartTrigger.split('T')[0]}
                        </p>
                        <p>
                          Start Time :
                          {' '}
                          {latestDeleteIndexJobDetails.StartTrigger.split('T')[1].split('.')[0]}
                        </p>
                        <p>
                          Duration :
                          {' '}
                          {durationofDeleteJob}
                          {' '}
                          sec
                        </p>
                        <p>
                          Status :
                          {' '}
                          {latestDeleteIndexJobDetails.FailedTrigger
                            ? <span style={{ color: 'red' }}>Failed</span> : <span style={{ color: 'green' }}>Passed</span>}
                        </p>
                        {latestDeleteIndexJobDetails.FailedTrigger ? (
                          <>
                            <p>
                              Message :
                              {' '}
                            </p>
                            <span>
                              {latestDeleteIndexJobDetails.Message}

                            </span>
                          </>
                        ) : (
                          <p>
                            Count :
                            {' '}
                            {totalDeleteProducts}

                          </p>
                        )}

                      </div>
                    </div>
                  )}

                </div>
              </>
            )}
          </Stack>
        </section>

      </div>
      <div>
        <p className="absolute text-lg right-4 text-error-400">
          Work In Progress - Not Final Version
        </p>
      </div>
    </Container>
  );
}

export default Dashboard;
